import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '../DialogActions';

import FormElement from '../FormElement';

import SecondaryDialogButton from '../SecondaryDialogButton';
import { Body1 } from '../Typography';

import QRGunIcon from '../Icons/QRGun';
import ResponsiveDialogHeader from '../ResponsiveDialogHeader';
import { processQRCode, QRType } from '../../utilities/qr';
import isStringSet from '../../utilities/is/isStringSet';
import classNames from 'classnames';
import defer from 'utilities/defer';

class QRCodeScannerDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qrCode: '',
            submitting: false
        };

        this.focusField = this.focusField.bind(this);
        this.reset = this.reset.bind(this);

        this.inputRef = React.createRef();
        this.hasMounted = false;
    }

    componentDidMount() {
        this.hasMounted = true;
    }

    componentWillUnmount() {
        this.hasMounted = false;
    }

    handleValueChanged = (event) => {
        this.setState({ qrCode: event.currentTarget.value });
    };

    reset() {
        if (this.hasMounted) {
            this.setState({ submitting: false, qrCode: '' });
        }
    }

    focusField() {
        // this method is a callback to refocus the input field after a dialog has been displayed
        defer(() => this.inputRef.current.focus({ preventScroll: false }), 250);
    }

    onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({ submitting: true });

        defer(() => {
            if (isStringSet(this.state.qrCode)) {
                processQRCode(this.state.qrCode || "").then(qrData => {

                    if (qrData.qrType !== QRType.Unknown) {

                        // clear the input field
                        if (qrData.qrType === QRType.Card) {

                            this.props.onCardScanned(qrData.qrCode, this.focusField);
                            defer(this.reset, 2000);

                        } else if (qrData.qrType === QRType.VisitorPass) {

                            this.props.onVisitorPassScanned(qrData.qrCode, this.focusField);
                            defer(this.reset, 2000);
                        }
                    } else {
                        this.props.onScanError("The QR code does not appear to be valid", this.focusField);
                        defer(this.reset);
                    }
                }).catch(err => {
                    console.error(err);
                    defer(this.reset);
                });
            }
        });

        return false;
    };

    onBlur = () => {
        this.focusField();
    };

    qrScannerDialogClose(handleClose) {
        return (_event, reason) => {
            if (reason === 'backdropClick')
                return;
            handleClose();
        };
    }

    render() {
        const {
            classes,
            open,
            handleClose,
            title
        } = this.props;

        const { submitting } = this.state;
        const fullScreen = false;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={this.qrScannerDialogClose(handleClose)}
            >

                <ResponsiveDialogHeader
                    handleClose={handleClose}
                    fullScreen={fullScreen}
                    title={title} />

                <DialogContent id="qr-dialog-description">
                    <Body1 paragraph>
                        Ensure the text field below has focus and scan a card using an attached QR code scanner
                    </Body1>
                    {!submitting &&
                        <form onSubmit={this.onSubmit}>
                            <FormElement className={classes.formElement} fullWidth>
                                <Paper className={classNames(classes.inputRoot, classes.inputFocus)}>
                                    <InputBase
                                        className={classes.input}
                                        name="qrcode"
                                        autoComplete="off"
                                        inputRef={this.inputRef}
                                        autoFocus
                                        disabled={submitting}
                                        onBlur={this.onBlur}
                                        value={this.state.qrCode}
                                        onChange={this.handleValueChanged}
                                    />
                                    <IconButton className={classes.iconButton} disabled>
                                        <QRGunIcon className={classes.icon} />
                                    </IconButton>

                                </Paper>
                            </FormElement>
                        </form>
                    }
                    {submitting &&
                        <Grid container alignItems="center" justifyContent="flex-start" spacing={2}>
                            <Grid item>
                                <CircularProgress color="secondary" />
                            </Grid>
                            <Grid item>
                                <Body1>Reading QR Code....</Body1>
                            </Grid>
                        </Grid>

                    }
                </DialogContent>
                {!fullScreen &&
                    <DialogActions fullScreen={fullScreen}>
                        <SecondaryDialogButton onClick={handleClose}>
                            Cancel
                        </SecondaryDialogButton>
                    </DialogActions>
                }
            </Dialog>
        );
    }
}

QRCodeScannerDialog.propTypes = {
    onCardScanned: PropTypes.func.isRequired,
    onVisitorPassScanned: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    onScanError: PropTypes.func,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool,
};

export default withStyles(styles)(QRCodeScannerDialog);